import React from "react";

import { Container, Row } from "reactstrap";

import ProjectItem from "./ProjectItem";

export default class Projects extends React.Component {
  render() {
    const { projects } = this.props;

    return (
      <section id="projects" className="mb-5 pt-5">
        <Container className="mt-0 pt-5">
          <h1 className="display-4 text-center marble-black-text">
            Some projects I designed or contributed to
          </h1>
          <Row className="py-3">
            {projects.map((project, index) => (
              <ProjectItem
                project={project}
                key={project.slug}
                // className={`order-md-${(index + 3) % 4}`}
              />
            ))}
          </Row>
        </Container>
      </section>
    );
  }
}

